import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CreateUpdateFormComponent } from "./components/create-update-form/create-update-form.component";
import { GenericCrudService } from "./service/generic-crud.service";
import { GenericFormModule } from "@cv-invision/cv.invision-views.ux";
import { EditableTableComponent } from "./components/editable-table/editable-table.component";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { BaseTableComponent } from "./components/base-table.component";
import { InputTextModule } from "primeng/inputtext";
import { InputSwitchModule } from "primeng/inputswitch";


@NgModule({
	imports: [
		GenericFormModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TableModule,
		ToastModule,
		ConfirmDialogModule,
		DropdownModule,
		InputTextModule,
		InputSwitchModule
	],
	declarations: [
		CreateUpdateFormComponent,
		BaseTableComponent,
		EditableTableComponent
	],
	exports: [
		CreateUpdateFormComponent,
		BaseTableComponent,
		EditableTableComponent
	],
	providers: [
		GenericCrudService
	]
})

export class GenericCrudModule {
}
